/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsDeleteAodRulesByIdMutationResponse, AuditReportsDeleteAodRulesByIdPathParams, AuditReportsDeleteAodRulesById401, AuditReportsDeleteAodRulesById403 } from "../models/AuditReportsDeleteAodRulesById";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsDeleteAodRulesById } from "../axios/auditReportsDeleteAodRulesById";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsDeleteAodRulesByIdMutationKey = () => [{ url: '/audit-reports/v1/aod-rules/:id' }] as const

export type AuditReportsDeleteAodRulesByIdMutationKey = ReturnType<typeof auditReportsDeleteAodRulesByIdMutationKey>

export function auditReportsDeleteAodRulesByIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsDeleteAodRulesByIdMutationKey()
        return mutationOptions<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, {id: AuditReportsDeleteAodRulesByIdPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsDeleteAodRulesById(id, config)
          },
        })

}

/**
 * @summary Delete a single AodRule
 * {@link /audit-reports/v1/aod-rules/:id}
 */
export function useAuditReportsDeleteAodRulesById<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, {id: AuditReportsDeleteAodRulesByIdPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsDeleteAodRulesByIdMutationKey()

          const baseOptions = auditReportsDeleteAodRulesByIdMutationOptions(config) as UseMutationOptions<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, {id: AuditReportsDeleteAodRulesByIdPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, {id: AuditReportsDeleteAodRulesByIdPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsDeleteAodRulesByIdMutationResponse, ResponseErrorConfig<AuditReportsDeleteAodRulesById401 | AuditReportsDeleteAodRulesById403>, {id: AuditReportsDeleteAodRulesByIdPathParams["id"]}, TContext>
      
}